import { StoreId } from "../../decorators/StoreIdDecorator";
import API from "../API";

type BatchClassRoleViewModelData = {
  role: number;
  batchClassId: string;

  editBatchClassSettings?: boolean;
  modelMigration?: boolean;
  batchMigration?: boolean;
  auditTrail?: boolean;
  viewReports?: boolean;
};

export default class BatchClassRoleViewModel {
  @StoreId
  role: number;
  batchClassId: string;

  editBatchClassSettings: boolean;
  modelMigration: boolean;
  batchMigration: boolean;
  auditTrail: boolean;
  viewReports: boolean;

  static roleProperties: { key: string; label: string | null }[] = [
    { key: "editBatchClassSettings", label: "Edit Batch Class Settings" },
    { key: "modelMigration", label: "Template Migration" },
    { key: "batchMigration", label: "Batch Migration" },
    { key: "auditTrail", label: "Audit Trail" },
    { key: "viewReports", label: "View Reports" },
  ];

  constructor(data: BatchClassRoleViewModelData) {
    this.role = data.role;
    this.batchClassId = data.batchClassId;

    this.editBatchClassSettings = data.editBatchClassSettings ?? false;
    this.modelMigration = data.modelMigration ?? false;
    this.batchMigration = data.batchMigration ?? false;
    this.auditTrail = data.auditTrail ?? false;
    this.viewReports = data.viewReports ?? false;
  }

  changeRolePropertyValue(propertyName: string, value: any) {
    //@ts-expect-error
    this[propertyName] = value;
  }

  getRolePropertyValue(propertyName: string): any {
    //@ts-expect-error
    return this[propertyName];
  }
  getSaveModel(): SaveBatchClassRoleViewModel {
    return new SaveBatchClassRoleViewModel(this);
  }

  static createTest(
    rest: Partial<BatchClassRoleViewModelData> = {},
  ): BatchClassRoleViewModel {
    const data: BatchClassRoleViewModelData = {
      batchClassId: "",
      role: 0,
      batchMigration: false,
      editBatchClassSettings: false,
      modelMigration: false,
      auditTrail: false,
      viewReports: false,
    };

    return new BatchClassRoleViewModel({
      ...data,
      ...rest,
    });
  }
}
class SaveBatchClassRoleViewModel {
  role: number;
  batchClassId: string;

  editBatchClassSettings: boolean;
  modelMigration: boolean;
  batchMigration: boolean;
  auditTrail: boolean;
  viewReports: boolean;
  constructor(data: BatchClassRoleViewModel) {
    this.role = data.role;
    this.batchClassId = data.batchClassId;
    this.editBatchClassSettings = data.editBatchClassSettings;
    this.modelMigration = data.modelMigration;
    this.batchMigration = data.batchMigration;
    this.auditTrail = data.auditTrail;
    this.viewReports = data.viewReports;
  }

  async save(): Promise<boolean> {
    return await API.post(`/v0/role/${this.batchClassId}`, null, this)
      .then((value: Response) => value.text())
      .then((value: string) => value === "true")
      .catch(() => {
        return false;
      });
  }
}
export { BatchClassRoleViewModelData, SaveBatchClassRoleViewModel };
